import { animated, useSpring } from "@react-spring/web";
import React from "react";

const RequestTicketIcon = () => {
  const movement = 20;
  const animation = useSpring({
    from: {
      transform: `translateX(-${movement}px)`,
    },
    to: [
      { transform: `translateX(${movement}px)` },
      { transform: `translateX(-${movement}px)` },
    ],
    config: {
      duration: 500,
    },
    reset: true,
    reverse: true,
    loop: true,
  });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="350"
      height="273"
      fill="none"
      viewBox="0 0 332 291"
    >
      <path
        fill="#FD9401"
        d="M216.566 19.32H111.18C49.777 19.32 0 69.099 0 130.502s49.777 111.18 111.18 111.18h105.386c61.403 0 111.18-49.777 111.18-111.18 0-61.403-49.777-111.18-111.18-111.18z"
        opacity="0.1"
      ></path>
      <path
        fill="#FD9401"
        d="M192.427 259.853h-57.122c-4.492 0-8.142-3.65-8.142-8.142v-17.815h73.38v17.815c0 4.492-3.65 8.142-8.142 8.142h.026zM135.325 0h57.122c4.492 0 8.142 3.65 8.142 8.142v17.815h-73.38V8.142c0-4.492 3.65-8.142 8.142-8.142h-.026z"
      ></path>
      <path
        fill="#0092B1"
        d="M221.581 211.87H106.215l4.671 24.604a12.83 12.83 0 0012.608 10.439h80.807c6.151 0 11.46-4.39 12.609-10.439l4.671-24.604z"
      ></path>
      <path
        fill="#EE5040"
        d="M106.215 48.01h115.366l-4.671-24.605a12.83 12.83 0 00-12.609-10.439h-80.807c-6.151 0-11.46 4.39-12.608 10.44l-4.671 24.604z"
      ></path>
      <path
        fill="#2F3F59"
        d="M261.996 152.696c12.566-54.171-21.161-108.272-75.332-120.838C132.493 19.29 78.391 53.019 65.825 107.19c-12.566 54.171 21.162 108.272 75.333 120.838 54.171 12.567 108.272-21.161 120.838-75.332z"
      ></path>
      <path
        fill="#fff"
        d="M163.898 205.285c41.612 0 75.345-33.733 75.345-75.345s-33.733-75.345-75.345-75.345-75.345 33.733-75.345 75.345 33.733 75.345 75.345 75.345z"
      ></path>
      <path
        fill="#0072A7"
        d="M157.555 129.787a6.72 6.72 0 016.712-6.713h30.041a6.721 6.721 0 016.713 6.713 6.721 6.721 0 01-6.713 6.713h-30.041a6.72 6.72 0 01-6.712-6.713z"
      ></path>
      <path
        fill="#0072A7"
        d="M164.267 136.5a6.72 6.72 0 01-6.712-6.713V83.743a6.72 6.72 0 016.712-6.712 6.721 6.721 0 016.713 6.712v46.044a6.721 6.721 0 01-6.713 6.713z"
      ></path>
      <path
        fill="#2F3F59"
        d="M91.476 87.19H7.86A7.861 7.861 0 000 95.05v156.944a7.86 7.86 0 007.861 7.861h83.615a7.86 7.86 0 007.861-7.861V95.051a7.861 7.861 0 00-7.861-7.862z"
      ></path>
      <path
        fill="#2699B9"
        d="M89.743 104.622H9.625v124.784h80.118V104.622z"
      ></path>
      <path
        fill="#fff"
        d="M31.953 138.234c0-6.687 5.207-11.613 12.302-11.613 7.096 0 12.277 4.9 12.277 11.613 0 6.712-5.232 11.613-12.277 11.613-7.044 0-12.302-4.952-12.302-11.613zm19.321 0c0-4.263-3.011-7.198-7.019-7.198-4.007 0-7.019 2.91-7.019 7.198s3.012 7.197 7.02 7.197c4.007 0 7.018-2.909 7.018-7.197zM67.37 127.003v22.461h-5.206v-18.3h-4.492v-4.161h9.699z"
      ></path>
      <path
        fill="#00BA84"
        d="M257.519 89.335c21.299 0 38.566-17.266 38.566-38.565 0-21.3-17.267-38.566-38.566-38.566-21.299 0-38.566 17.266-38.566 38.566 0 21.299 17.267 38.565 38.566 38.565z"
      ></path>
      <path
        fill="#fff"
        d="M252.646 68.763l-15.289-15.289 5.59-5.615 9.163 9.138 19.474-23.456 6.1 5.079-25.038 30.143zM70.782 170.649H28.566v6.688h42.216v-6.688zM70.782 184.177H28.566v6.687h42.216v-6.687zM70.782 197.704H28.566v6.687h42.216v-6.687z"
      ></path>
      <path
        stroke="#2F3F59"
        strokeMiterlimit="10"
        d="M60.465 36.37H26.34M43.418 53.42v-34.1M332 105.427h-34.125M314.922 122.477V88.352"
      ></path>
      <animated.g clipPath="url(#clip0_2356_61907)" style={animation}>
        <path
          fill="#F29F05"
          fillRule="evenodd"
          d="M151.614 199.498l139.07-72.893c2.672-1.406 5.986-.359 7.386 2.323l29.828 57.348a5.512 5.512 0 01-2.314 7.414l-139.07 72.893c-2.671 1.391-5.986.344-7.386-2.323L149.3 206.897c-1.4-2.681-.357-6.008 2.314-7.414v.015z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#F2B705"
          fillRule="evenodd"
          d="M147.77 223.117l139.056-72.893c2.671-1.405 5.985-.359 7.385 2.323l29.829 57.348c1.385 2.682.343 6.009-2.315 7.414l-139.07 72.893c-2.671 1.405-5.985.359-7.385-2.323l-29.828-57.362c-1.386-2.682-.343-6.009 2.314-7.414l.014.014z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M164.757 236.812c.143.172.585.158 1.228.029.7 1.677 1.129 3.599 1.257 5.793.857-.401 1.372-1.133 1.529-2.036l.986-4.905c1.8-.645 3.157-1.305 3.828-1.591l7.8-3.327c1.6 2.394.443 12.117.3 15.258.957.272 1.729-1.133 2.143-2.166l.843-3.8.228-1.047 1.186-5.349c.557-.043 1.429-.329 1.814-.53l.529-.273-.643-1.233-.529.272c-.242.13-.6.373-.928.646l1.128-4.69c.086-.702.658-.989 1.358-1.362l.085-.043 2.786-1.764c1.343-.86 4.443-3.284 4.114-4.173-.528-.789-4.285.387-5.757 1.004l-3.043 1.291-.085.043c-.715.358-1.272.674-1.9.344l-4.472-1.75c.415-.114.829-.258 1.057-.387l.529-.272-.643-1.234-.528.273c-.4.201-1.129.76-1.486 1.19l-5.057-2.079-.986-.402-3.586-1.477c-1.071-.258-2.685-.416-3 .516 2.643 1.692 11.257 6.281 12.3 8.977l-7.185 4.532c-.629.387-1.943 1.133-3.5 2.252l-4.586-1.994c-.829-.387-1.714-.387-2.543.101 1.714 1.362 3.043 2.81 4.014 4.359-.457.445-.728.818-.671 1.033l.086-.029z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#20354A"
          d="M162.708 237.321l-10.776 5.648.277.534 10.777-5.648-.278-.534zM162.112 236.245l-10.778 5.647.284.546 10.778-5.646-.284-.547zM163.252 238.401l-10.777 5.646.284.547 10.777-5.646-.284-.547z"
        ></path>
        <path
          fill="#20354A"
          fillRule="evenodd"
          d="M300.684 164.995l-10.786 5.65.286.545 10.786-5.65-.286-.545zM300.127 163.919l-10.785 5.65.286.545 10.771-5.65-.272-.545zM301.242 166.084l-10.771 5.651.285.53 10.772-5.636-.286-.545z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M261.269 179.45l-.543.287-2.814-5.407.543-.287 2.814 5.407zM264.927 186.491l-.542.287-2.815-5.421.543-.272 2.814 5.406zM268.584 193.518l-.543.287-2.814-5.406.542-.287 2.815 5.406z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M269.423 195.152l-.544.286 2.826 5.411.544-.286-2.826-5.411zM273.081 202.188l-.532.279 2.818 5.414.532-.279-2.818-5.414zM276.759 209.203l-.544.285 2.817 5.415.545-.285-2.818-5.415z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M283.213 221.654l-.543.287-2.815-5.42.543-.273 2.815 5.406zM286.869 228.681l-.543.287-2.814-5.406.543-.287 2.814 5.406zM289.155 234.389l-1.971-3.8.528-.287 1.986 3.814-.543.273z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M254.784 167.033l-.532.279 2.818 5.414.531-.278-2.817-5.415z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M254.055 183.637l-48.657 25.512a.664.664 0 01-.9-.287l-1.514-2.911a.669.669 0 01.286-.903l48.657-25.498a.664.664 0 01.9.287l1.514 2.911a.67.67 0 01-.286.904v-.015zM258.17 191.553l-48.656 25.512a.664.664 0 01-.9-.287l-1.515-2.911a.67.67 0 01.286-.903l48.657-25.498a.664.664 0 01.9.287l1.514 2.911a.67.67 0 01-.286.904v-.015zM262.284 199.483l-48.657 25.498a.664.664 0 01-.9-.287l-1.514-2.911a.67.67 0 01.285-.904l48.657-25.497a.664.664 0 01.9.287l1.514 2.911a.668.668 0 01-.285.903zM266.399 207.399l-48.657 25.498a.664.664 0 01-.9-.287l-1.514-2.911a.67.67 0 01.286-.904l48.656-25.497a.664.664 0 01.9.287l1.515 2.911a.67.67 0 01-.286.903zM253.828 224.063l-31.957 16.75a.664.664 0 01-.9-.287l-1.514-2.911a.668.668 0 01.286-.903l31.971-16.75a.664.664 0 01.9.287l1.514 2.911a.669.669 0 01-.286.903h-.014z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#E1EEF6"
          d="M204.722 252.292l-27.72 14.529 6.704 12.89 27.72-14.529-6.704-12.89z"
        ></path>
        <path
          fill="#435D76"
          d="M179.934 266.497l-.862.449 4.847 9.367.862-.45-4.847-9.366zM181.64 265.6l-.861.451 4.872 9.37.861-.451-4.872-9.37zM186.808 262.886l-.861.451 4.873 9.369.861-.452-4.873-9.368zM191.987 260.171l-.862.45 4.863 9.374.862-.45-4.863-9.374zM196.486 257.802l-.861.452 4.875 9.368.861-.452-4.875-9.368z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M182.041 265.378l.429-.229 4.871 9.364-.429.23-4.871-9.365z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M187.649 262.455l-.43.225 4.873 9.369.43-.226-4.873-9.368zM192.815 259.749l-.43.226 4.873 9.369.43-.226-4.873-9.369zM197.329 257.366l-.431.226 4.877 9.367.43-.225-4.876-9.368zM184.353 264.182l-.861.451 4.866 9.356.862-.451-4.867-9.356z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M188.656 261.922l.857-.459 4.872 9.365-.857.444-4.872-9.35z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M194.698 258.739l-.862.45 4.861 9.375.862-.45-4.861-9.375zM199.21 256.393l-.862.449 4.848 9.382.862-.449-4.848-9.382z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M182.77 264.991l.442-.215 5.715 11.014-.429.229-5.728-11.028z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M188.36 262.079l-.43.227 4.882 9.347.43-.226-4.882-9.348z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M193.113 259.585l.429-.23 4.871 9.365-.428.229-4.872-9.364z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M198.052 256.991l-.431.225 4.875 9.368.43-.225-4.874-9.368z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M180.156 266.368l.429-.215 4.871 9.35-.428.229-4.872-9.364zM185.328 263.657l.429-.215 4.871 9.365-.428.215-4.872-9.365zM190.498 260.947l.429-.215 4.871 9.364-.443.215-4.857-9.364zM194.998 258.595l.429-.229 4.871 9.364-.429.23-4.871-9.365z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M200.924 255.486l-.862.451 4.875 9.368.861-.451-4.874-9.368z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M201.342 255.269l.414-.23 4.871 9.379-.428.215-4.857-9.364zM202.77 254.523l.871-.459 4.857 9.364-.857.459-4.871-9.364z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M202.489 254.664l-.43.226 4.873 9.369.43-.226-4.873-9.369z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M199.441 256.258l.429-.215 4.871 9.364-.428.215-4.872-9.364z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#E1EEF6"
          d="M312.599 195.754l-27.72 14.529 6.704 12.89 27.72-14.529-6.704-12.89z"
        ></path>
        <path
          fill="#435D76"
          d="M287.804 209.953l-.861.452 4.873 9.369.861-.452-4.873-9.369zM289.534 209.06l-.862.449 4.842 9.385.862-.449-4.842-9.385z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M293.84 206.797l.857-.459 4.871 9.365-.871.444-4.857-9.35zM298.998 204.087l.871-.459 4.872 9.364-.872.459-4.871-9.364z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M304.377 201.282l-.861.45 4.863 9.374.861-.45-4.863-9.374zM290.383 208.609l-.432.224 4.834 9.389.431-.224-4.833-9.389z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M295.098 206.123l.428-.215 4.872 9.35-.429.23-4.871-9.365zM300.268 203.413l.428-.215 4.872 9.364-.429.215-4.871-9.364zM304.783 201.061l.429-.229 4.871 9.364-.443.229-4.857-9.364z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M292.253 207.616l-.862.449 4.845 9.367.862-.449-4.845-9.367zM297.408 204.901l-.861.452 4.874 9.368.861-.452-4.874-9.368zM302.572 202.208l-.861.451 4.871 9.37.861-.451-4.871-9.37zM307.078 199.854l-.861.452 4.871 9.369.861-.451-4.871-9.37z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M290.668 208.461l.429-.23 5.728 11.014-.443.215-5.714-10.999zM295.826 205.75l.443-.229 4.857 9.364-.428.215-4.872-9.35z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M301.457 202.797l-.432.224 4.829 9.391.432-.223-4.829-9.392zM305.949 200.432l-.431.225 4.853 9.379.431-.225-4.853-9.379zM288.473 209.613l-.43.227 4.883 9.347.43-.226-4.883-9.348zM293.655 206.878l-.43.226 4.876 9.367.43-.226-4.876-9.367z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M298.383 204.403l.428-.215 4.872 9.364-.429.215-4.871-9.364zM302.883 202.051l.428-.23 4.872 9.365-.429.229-4.871-9.364z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M308.826 198.931l-.861.451 4.873 9.369.861-.451-4.873-9.369zM309.657 198.495l-.43.226 4.871 9.369.43-.225-4.871-9.37z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M310.654 197.978l.872-.459 4.871 9.364-.871.459-4.872-9.364z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#435D76"
          d="M310.357 198.132l-.429.227 4.913 9.348.43-.228-4.914-9.347z"
        ></path>
        <path
          fill="#435D76"
          fillRule="evenodd"
          d="M307.326 199.713l.429-.215 4.871 9.35-.428.23-4.872-9.365z"
          clipRule="evenodd"
        ></path>
      </animated.g>
      <defs>
        <clipPath id="clip0_2356_61907">
          <path
            fill="#fff"
            d="M0 0H183.684V164.845H0z"
            transform="translate(144.828 125.988)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default RequestTicketIcon;
